import cx from 'classnames';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';
import {PremiumIcon} from '~library/svg/PremiumIcon';
import {premiumColor} from '~libSass/base/_exports.sass';

export const OptionToggle = ({
  eviteExclusive = false,
  description,
  heading,
  dataQaId,
  icon,
  premiumBadge,
  ...props
}) => (
  <div
    className={`option-toggle ${props.checked ? 'toggled-on' : ''} ${
      eviteExclusive ? 'evite-exclusive' : ''
    }`}
  >
    {eviteExclusive && <span className="create-flow__evite-exclusive">Exclusively on Evite</span>}
    <div className="icon__text__wrapper">
      {icon}
      <div className="section-info">
        <Typography
          as="h4"
          variant="paragraph3"
          data-qa-id={`${dataQaId}-heading`}
          className={cx({'option-toggle__flex-heading': premiumBadge})}
        >
          {heading || ''}
          {premiumBadge && <PremiumIcon ratio={0.08} color={premiumColor} />}
        </Typography>
        <Typography as="p" variant="paragraph4" data-qa-id={`${dataQaId}-description`}>
          {description}
        </Typography>
        {props.footer}
      </div>
    </div>

    <div>
      <Input
        aria-label={dataQaId}
        data-qa-id={dataQaId}
        type="toggle"
        checked={props.checked}
        onChange={props.onChange}
      />
    </div>
  </div>
);
